export type OfficeHost = "excel" | "powerpoint";

export const OFFICE_HOST_HEADER = "X-Finster-Office-Host";

export type FinsterHostInfo = {
  host: string;
  hostTypeExcel: string;
  typeofExcel: string;
  typeofPowerPoint: string;
  isExcel: boolean;
  platform: string;
  officeJsAvailable: boolean;
};

declare global {
  interface Window {
    __FINSTER_HOST_INFO__?: FinsterHostInfo;
  }
}

/**
 * The bootstrap probe writes this once Office.js reports which application is
 * hosting the task pane. Until then the host is genuinely unknown, and callers
 * must leave the header off rather than guess: the add-in server treats an
 * absent header and an unrecognized one the same way, but a wrong header would
 * attribute the request to the other Office application.
 */
export function resolveOfficeHost(): OfficeHost | null {
  const hostInfo = window.__FINSTER_HOST_INFO__;
  if (!hostInfo) return null;
  return hostInfo.isExcel ? "excel" : "powerpoint";
}

export function officeHostHeaders(): Record<string, string> {
  const host = resolveOfficeHost();
  return host ? { [OFFICE_HOST_HEADER]: host } : {};
}
